import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfiguration } from '../config/app-configuration';
// import AppConfigService  from '../../assets/data/appConfig.json';

import {AppConfigService} from '../app-config.service.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private pendingHTTPRequests$ = new Subject<void>();

    constructor(private router: Router, private appConfig: AppConfiguration, private appConfigService: AppConfigService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let modifiedReq = req;

        // Si la ruta termina en /api8/FlexIntegration o /FlexIntegration, redirigir a api8utility/FlexIntegration/CallFlexCubeWorks
        // y agregar el token de localStorage al body.
        if (req.url.endsWith('/api8/FlexIntegration') || req.url.endsWith('/FlexIntegration')) {
            const dbToken = localStorage.getItem('db_token');
            let newUrl: string;

            newUrl = this.appConfigService.apiBaseUrlUtility + '/FlexIntegration/CallFlexCubeWorks';
            
            // if (req.url.endsWith('/api8/FlexIntegration')) {
            //     newUrl = req.url.replace('/api8/FlexIntegration', '/api8utility/FlexIntegration/CallFlexCubeWorks');
            // } else {
            //     // Si termina solo en /FlexIntegration, eliminar esa parte y agregar la nueva ruta
            //     const baseUrl = req.url.substring(0, req.url.length - '/FlexIntegration'.length);
            //     // newUrl = baseUrl + '/api8utility/FlexIntegration/CallFlexCubeWorks';
                
            // }

            modifiedReq = req.clone({
                url: newUrl,
                body: {
                    ...(req.body || {}),
                    action_token: dbToken
                }
            });
        }


        if (localStorage.getItem('token') != null) {
            if (modifiedReq.url == this.appConfig.urlInformation) {
                const clonedReq = modifiedReq.clone({
                    headers: modifiedReq.headers.set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
                });
                return next.handle(clonedReq).pipe(
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/logincubeworks');
                            }
                        }
                    )
                );

            } else {
                const clonedReq = modifiedReq.clone({
                    headers: modifiedReq.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                });
                return next.handle(clonedReq).pipe(
                    takeUntil(this.pendingHTTPRequests$.asObservable()),
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/logincubeworks');
                            }
                        }
                    )
                );
            }
        } else {
            return next.handle(modifiedReq.clone());
        }
    }
}
